module.exports = __webpack_public_path__ + "img/empty-photo.3f8ab101.svg";